import { render, staticRenderFns } from "./PrescrizioneSpecialisticaComponent.vue?vue&type=template&id=5987d3b2"
import script from "./PrescrizioneSpecialisticaComponent.vue?vue&type=script&lang=js"
export * from "./PrescrizioneSpecialisticaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports